import React, { useState, forwardRef, useImperativeHandle } from 'react';
import ReactDOM from 'react-dom';

const FullScreenImage = forwardRef((props, ref) => {
  const [visible, setVisible] = useState(false);
  const [imageSrc, setImageSrc] = useState('');

  useImperativeHandle(ref, () => ({
    showImage: (src) => {
      setImageSrc(src);
      setVisible(true);
    },
    hideImage: () => setVisible(false),
  }));

  if (!visible) return null;

  return ReactDOM.createPortal(
    <div
      onClick={() => setVisible(false)}
      style={{
        position: 'fixed',
        top: 0, left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(0, 0, 0, 0.95)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999,
        cursor: 'zoom-out',
      }}
    >
      <img
        src={imageSrc}
        alt="fullscreen"
        style={{
          maxWidth: '90%',
          maxHeight: '90%',
          objectFit: 'contain'
        }}
      />
    </div>,
    document.body
  );
});

export default FullScreenImage;
